
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoganpatipulebeachbusrentalsservice() {



  const cardData =
  {
    keyword: ' Pune to Ganpatipule Beach Bus Rental Service',
    heading: 'Vaishnavi Travels: Pune to Ganpatipule Beach Bus Rental Service',
    headingDescription: 'Vaishnavi Travels offers reliable and affordable Pune to Ganpatipule Beach Bus Rental Service, perfect for family trips, school excursions, corporate outings, and group tours. Our buses are spacious, well-maintained, and equipped with comfortable seating, strong air-conditioning, and ample luggage space to make the long coastal journey smooth and enjoyable. With professional drivers, on-time service, and flexible booking options, we ensure a safe and hassle-free travel experience. Whether it’s a religious yatra, holiday vacation, or beachside picnic, Vaishnavi Travels guarantees comfortable, punctual, and convenient bus rental services from Pune to Ganpatipule Beach.',

    top: 'Top Places to Visit in Ganpatipule with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is one of the cleanest and most serene beaches on the Konkan coast, known for its golden sands and turquoise waters. Unlike crowded beaches, it offers tranquility and unspoiled natural beauty. Tourists enjoy long walks, camel rides, horse rides, and water sports like motorboat rides. The sunsets here are breathtaking, painting the sky in shades of orange and red. Surrounded by casuarina and coconut trees, it is perfect for family picnics. Ganpatipule Beach is the heart of this coastal town and a paradise for beach lovers."
  },
  {
    "title": "Swayambhu Ganpati Temple",
    "description": "The Swayambhu Ganpati Temple, located right on the beach, is a 400-year-old shrine dedicated to Lord Ganesha. The idol is believed to have self-manifested from the sand and is worshipped as highly powerful. Thousands of devotees visit daily, especially during Ganesh Chaturthi and Magh Chaturthi. The temple’s unique seaside setting adds to its divine aura. Early morning aarti with sea waves in the background creates a mesmerizing spiritual atmosphere. Swayambhu Ganpati Temple is Ganpatipule’s sacred spiritual gem."
  },
  {
    "title": "Jaigad Fort",
    "description": "Situated 20 km from Ganpatipule, Jaigad Fort is a 16th-century sea fort that offers panoramic views of the Arabian Sea and Jaigad Creek. Once a strategic Maratha stronghold, it still preserves bastions, gateways, and water tanks. Visitors love exploring its rugged stone walls and watching the confluence of river and sea. The fort also houses a lighthouse, adding charm to the coastal scenery. History lovers find it a fascinating trip back to Maratha naval power. Jaigad Fort is Ganpatipule’s proud historic guardian on the coast."
  },
  {
    "title": "Jaigad Lighthouse",
    "description": "The Jaigad Lighthouse, located near Jaigad Fort, is a popular spot for panoramic coastal views. Visitors climb to the top for breathtaking vistas of the Arabian Sea, Jaigad Creek, and lush greenery. The lighthouse, still operational, guides ships along the Konkan coast. Its unique location makes it a photographer’s delight. A visit here combines history with natural beauty. Jaigad Lighthouse is Ganpatipule’s scenic vantage point for sea lovers and explorers."
  },
  {
    "title": "Prachin Konkan Museum",
    "description": "Prachin Konkan Museum is a heritage village-style museum that brings alive the traditional lifestyle of the Konkan region. Life-size models showcase local occupations, customs, and cultural practices from centuries past. Visitors learn about agriculture, fishing, crafts, and festivals of coastal Maharashtra. The museum also features a medicinal plant garden and exhibits on Konkan’s rich biodiversity. It is an educational yet entertaining stop for families. Prachin Konkan Museum is Ganpatipule’s cultural window to tradition and history."
  },
  {
    "title": "Aare Ware Beach",
    "description": "Aare Ware Beach is a twin stretch of pristine coastline located a few kilometers from Ganpatipule. Surrounded by lush hills and coconut groves, the beach offers solitude and natural beauty. Its winding coastal road itself is a highlight, offering stunning sea views at every turn. Tourists love stopping here for photography and peaceful moments. The beach remains less commercialized, perfect for nature lovers. Aare Ware Beach is Ganpatipule’s hidden coastal jewel."
  },
  {
    "title": "Velneshwar Beach and Temple",
    "description": "Velneshwar Beach, about 30 km from Ganpatipule, is a quiet beach famous for its ancient Shiva temple. The crescent-shaped shoreline is ideal for swimming, sunbathing, and picnics. Devotees visit the Velneshwar Temple, especially during Maha Shivratri when grand celebrations are held. The beach is clean and less crowded, offering a serene escape. Coconut palms lining the shore enhance its beauty. Velneshwar is Ganpatipule’s perfect blend of devotion and seaside relaxation."
  },
  {
    "title": "Thiba Palace, Ratnagiri",
    "description": "Thiba Palace, located in Ratnagiri (25 km from Ganpatipule), was built in 1910 for the exiled King Thibaw of Burma. The palace is a blend of European and Indian architecture with intricate wooden carvings and a sprawling layout. Tourists enjoy exploring its historical exhibits and learning about the king’s life in exile. The palace gardens add charm to the experience. History enthusiasts find it a fascinating piece of colonial-era history. Thiba Palace is Ganpatipule’s nearby heritage attraction."
  },
  {
    "title": "Ratnadurga Fort",
    "description": "Ratnadurga Fort, overlooking the Arabian Sea in Ratnagiri, is a large sea fort offering spectacular views and history. The fort covers a vast area with bastions, temples, and watchtowers. The Bhagwati Temple inside is a major attraction for devotees. Surrounded by the sea on three sides, it creates a dramatic coastal panorama. Trekkers and history lovers enjoy exploring its ruins and scenic pathways. Ratnadurga Fort is Ganpatipule’s nearby historic and scenic wonder."
  },
  {
    "title": "Ganeshgule Beach and Temple",
    "description": "Ganeshgule, located about 20 km from Ganpatipule, is known for its secluded beach and ancient Ganesh temple. The temple is believed to be older than the Ganpatipule shrine and holds immense religious value. The beach here is untouched, making it ideal for peace seekers. Its offbeat charm attracts photographers and spiritual travelers alike. Surrounded by hills and greenery, it offers a serene escape. Ganeshgule is Ganpatipule’s offbeat blend of faith and natural beauty."
  }
],

"services": [
{
"name": "Pune to Ganpatipule Bus Hire",
"description": "Reliable and comfortable bus rental service for trips from Pune to Ganpatipule, catering to families, groups, and tourists planning a beach or religious getaway. Our buses offer spacious seating, timely pickups, and flexible itineraries to ensure a smooth and enjoyable journey. Ideal for weekend trips and holiday tours."
},
{
"name": "Beach Trip Bus from Pune",
"description": "Specialized beach trip bus services from Pune designed to provide a relaxing and fun travel experience to Ganpatipule and other coastal destinations. Equipped with air-conditioned and non-AC options, these buses ensure your group travels comfortably with ample storage for beach gear and luggage."
},
{
"name": "AC Bus to Ganpatipule",
"description": "Air-conditioned bus rentals from Pune to Ganpatipule offering a cool and luxurious journey along the scenic route. Perfect for families and corporate groups seeking comfort during long drives, with modern amenities like reclining seats, clean interiors, and courteous drivers for a hassle-free trip."
},
{
"name": "Ganpatipule Group Tour Bus",
"description": "Group tour bus services dedicated to Ganpatipule tours, providing well-maintained vehicles that accommodate various group sizes. These buses come with onboard entertainment options and sufficient luggage space, making them ideal for family outings, school trips, and organized group tours."
},
{
"name": "Non AC Ganpatipule Bus Pune",
"description": "Affordable non-AC bus rentals for travel from Pune to Ganpatipule, designed for budget-conscious groups without compromising safety or comfort. These buses are ideal for short trips and large groups, providing sturdy seating and reliable transportation for beach vacations and religious visits."
},
{
"name": "Beach Vacation Bus Rental Pune",
"description": "Tailored bus rental services for beach vacations from Pune to Ganpatipule and nearby coastal destinations. Whether planning a weekend getaway or a longer holiday, our buses offer flexible scheduling, clean interiors, and courteous drivers to enhance your travel experience."
},
{
"name": "40 Seater Ganpatipule Bus",
"description": "Spacious 40-seater buses available for Ganpatipule trips from Pune, perfect for medium to large groups. These buses feature comfortable seating, ample legroom, and large luggage compartments to accommodate all passengers’ needs, ensuring a smooth and pleasant journey."
},
{
"name": "Religious Trip Bus to Ganpatipule",
"description": "Dedicated bus services for religious trips from Pune to Ganpatipule, focusing on convenience, punctuality, and comfort for devotees. Our buses are equipped to handle group travel with ease, ensuring timely arrivals for temple visits and smooth returns."
},
{
"name": "Outstation Bus for Beach Trip",
"description": "Reliable outstation bus rentals for beach trips from Pune to Ganpatipule, providing both AC and non-AC options to suit different group sizes and budgets. These buses offer a safe and comfortable mode of transport for long-distance travel to coastal destinations."
},
{
"name": "Pune to Ganpatipule Family Bus",
"description": "Family-friendly bus hire services from Pune to Ganpatipule, designed to keep groups together with spacious seating and onboard amenities. Perfect for family vacations, ensuring convenience and comfort throughout the journey."
},
{
"name": "Pune to Ganpatipule Holiday Bus",
"description": "Comprehensive holiday bus rental services from Pune to Ganpatipule, including flexible pick-up/drop-off points, clean vehicles, and experienced drivers. Ideal for tourists looking for hassle-free transport during their beach vacation."
},
{
"name": "Group Travel Bus Hire Ganpatipule",
"description": "Customizable group travel bus hire options from Pune to Ganpatipule catering to various event types such as family reunions, school excursions, and corporate outings. Our fleet includes buses with modern amenities to ensure comfort and convenience."
},
{
"name": "Ganpatipule Picnic Bus Rental Pune",
"description": "Specialized picnic bus rentals from Pune to Ganpatipule designed for day trips and short excursions. These buses provide flexible schedules, clean interiors, and comfortable seating to make your picnic outing enjoyable and stress-free."
}
],
"tableData": [
["Pune to Ganpatipule Bus Hire", "Beach Trip Bus from Pune"],
["AC Bus to Ganpatipule", "Ganpatipule Group Tour Bus"],
["Non AC Ganpatipule Bus Pune", "Beach Vacation Bus Rental Pune"],
["40 Seater Ganpatipule Bus", "Religious Trip Bus to Ganpatipule"],
["Outstation Bus for Beach Trip", "Pune to Ganpatipule Family Bus"],
["Pune to Ganpatipule Holiday Bus", "Group Travel Bus Hire Ganpatipule"],
["Ganpatipule Picnic Bus Rental Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Ganpatipule Beach Bus Rental Service",
    "WhyChoosedescription": "Vaishnavi Travels offers dependable bus rental services from Pune to Ganpatipule Beach, ideal for group outings and beach trips."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and cushioned seats to ensure a relaxing and enjoyable journey to Ganpatipule Beach."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to uphold high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Beach Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your Ganpatipule Beach travel plans."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Ganpatipule Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service, with expert knowledge of the Pune to Ganpatipule route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Family Outings, Corporate Trips, and Group Travel",
    "WhyChoosedescription": "Perfect for beach outings, corporate excursions, family trips, and group travel from Pune to Ganpatipule Beach."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer support to assist with bookings, changes, and travel inquiries."
  }
]






















  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus rental services from Pune to Ganpatipule Beach?',
      answer: 'Yes, Vaishnavi Travels provides comfortable and reliable bus rental services from Pune to Ganpatipule Beach, perfect for family outings, group tours, and corporate trips.',
    },
    {
      question: 'What types of buses are available for Pune to Ganpatipule Beach trips?',
      answer: 'We offer a range of buses including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, tailored to your group size and travel preferences.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Ganpatipule Beach?',
      answer: 'Rental prices depend on the bus type and duration, typically starting from ₹12,000 for a day trip for a 32 seater tempo traveller. We provide customized quotes based on your itinerary and requirements.',
    },
    {
      question: 'Are drivers included in the bus rental service?',
      answer: 'Yes, all rentals include experienced and professional drivers who are familiar with the Pune-Ganpatipule route to ensure a safe and pleasant journey.',
    },
    {
      question: 'Can the itinerary be customized for the Ganpatipule Beach trip?',
      answer: 'Absolutely. We can customize the trip itinerary, including stops and timings, according to your group’s preferences.',
    },
    {
      question: 'How far in advance should I book the Pune to Ganpatipule Beach bus?',
      answer: 'Booking at least 4-6 days in advance is recommended, especially during peak tourist seasons and weekends, to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the rental fare?',
      answer: 'Tolls, parking fees, driver allowances, and any permits are typically extra and will be clearly communicated in your rental quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ajay Kulkarni",
    position: "Tour Coordinator",
    feedback:
      "We hired a 40 seater AC bus from Vaishnavi Travels for our Pune to Ganpatipule Beach trip. The bus was clean and comfortable, and the driver was punctual and professional. The entire experience was smooth and enjoyable.",
    rating: 5,
  },
  {
    name: "Mrs. Meenal Deshpande",
    position: "Family Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service for our family outing to Ganpatipule Beach. The 32 seater tempo traveller was well-maintained and spacious. The driver was courteous and handled the long journey efficiently. Highly recommend their services!",
    rating: 5,
    style: "style-2",
  }
];





















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ganpatipule Beach Bus Rental Service",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-ganpatipule-beach-bus.jpg",
  "description": "Book Pune to Ganpatipule beach bus rental with Vaishnavi Travels for comfortable AC and Non AC buses ideal for family vacations, religious trips, and group tours.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.81",
    "ratingCount": "1480"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4600",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-ganpatipule-beach-bus-rental-service"
  }
};




  return (
    <div>
<Helmet>
  <title>Pune to Ganpatipule Beach Bus Rental Service | AC & Non AC Beach Trip Bus | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Ganpatipule beach bus rental with Vaishnavi Travels for comfortable AC and Non AC buses ideal for family vacations, religious trips, and group tours."
  />
  <meta
    name="keywords"
    content="Pune to Ganpatipule Bus Hire, Beach Trip Bus from Pune, AC Bus to Ganpatipule, Ganpatipule Group Tour Bus, Non AC Ganpatipule Bus Pune, Beach Vacation Bus Rental Pune, 40 Seater Ganpatipule Bus, Religious Trip Bus to Ganpatipule, Outstation Bus for Beach Trip, Pune to Ganpatipule Family Bus, Pune to Ganpatipule Holiday Bus, Group Travel Bus Hire Ganpatipule, Ganpatipule Picnic Bus Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoganpatipulebeachbusrentalsservice;